import { ComboboxItem, Group, Select } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { HierarchyDepartmentSelect, HierarchyDepartmentSelectProps } from '@feature/utils';

export interface HierarchyFacultySelectProps extends HierarchyDepartmentSelectProps {
  facultyOptions: ComboboxItem[];
  facultyValue: string | null;

  onFacultyChange: (_value: string | null, option: ComboboxItem) => void;
}

export function HierarchyFacultySelect(props: HierarchyFacultySelectProps) {
  const { facultyOptions, facultyValue, onFacultyChange, isDisabled, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <Group wrap="nowrap">
      <Select
        miw="150px"
        label={t('hierarchy.faculty')}
        placeholder={t('hierarchy.faculty')}
        searchable
        data={facultyOptions}
        disabled={isDisabled}
        value={facultyValue}
        onChange={onFacultyChange}
      />
      <HierarchyDepartmentSelect
        isDisabled={facultyValue == null || isDisabled}
        {...restProps}
      />
    </Group>
  );
}
